<template>
<main class="J-body-container">
    <component-modaldescription/>
    <v-layout row wrap style="margin:0" >
        <v-flex md7 sm12 xs12 class="p-4">
            <v-layout column>
                <div class="J-container--box" style="margin:0">
                    <div class="J-ubication-content" v-if="false">
                        <div class="J-search-ubication-content" v-for="(share,i) in shares" :key="i+1" @click="shareUbication(share)" :class="{'active':share.active}">
                            <div class="J-search-ubication-text">
                               {{share.name}}
                            </div>
                            <span class="J-search-list-icon">
                               <i :class="share.icon"></i>
                            </span>
                            
                        </div>
                        <div style="color:#fa5252;text-align:center;" v-if="user_conversation">
                            <span v-if="user_conversation.permission">
                                <b style="text-transform:capitalize">{{user_conversation.name}}</b>                                
                                está compartiendo su ubicacion
                            </span> 
                        </div>
                    </div>
                    <div id="map-wrap" :style="'height:550px;position:relative; z-index:1'">
                        <l-map :center="[latitude,longitude]" :zoom=12 >
                            <l-tile-layer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                            <div>
                                <l-circle-marker  v-if="user_help_location&&user_conversation" :lat-lng="[user_help_location[1], user_help_location[0]]" :fillColor="color" :fillOpacity="1" color="#fff">
                                    <l-popup v-if="user_conversation.user!=undefined">
                                        
                                        <div class="J-help-container">
                                            <h4 class="J-help-title" v-if="user_conversation">{{user_conversation.user.name}}</h4>
                                            <div class="J-help-content" v-if="user_conversation.user.message!=undefined">
                                                <div class="J-help-message" :style="'background-color:#'+color">
                                                    {{user_conversation.user.message}}
                                                </div>
                                                <div class="J-help-address">
                                                    {{user_conversation.location.direction}}
                                                </div>
                                            </div>
                                        </div>
                                    </l-popup>
                                </l-circle-marker>
                                <l-circle-marker v-if="user_location" :lat-lng="[user_location[1], user_location[0]]" fillColor="#3388FF" :fillOpacity="1" color="#fff">
                                    <l-popup  class="text-xs-center">
                                        <div class="J-help-content">
                                            <div class="J-help-message" :style="'background-color:#'+user_help.color">
                                                Creaste este mensaje: {{user_help.message}}
                                            </div>
                                        </div>
                                        <button class="btn btn-sm J-help-btn" style="color: white;margin:5%" @click="finishHelp(user_help)">Finalizar</button>
                                    </l-popup>
                                </l-circle-marker>
                            </div>
                        </l-map>
                    </div>
                </div>                
            </v-layout>

        </v-flex >
        <v-flex md5 sm12 xs12  class="p-4">
            <div
                id="e3"
                style=" margin: auto;"
                class="lighten-3">
                <component-conversation v-if="false" :data_conversation="user_conversation" :is_company="false" @back="isTabActive"/>
                <div v-if="tabs[1].active" class="">
                    <component-new-message :data="datamessage" :office="user" @back="isTabActive" @select="selectUser"/>
                </div>
                <div>
                    <div style="color:#fa5252;text-align:center;" v-if="user_conversation">
                        <span v-if="user_conversation.user"> Ayudando a </span> 
                        <span v-else>Recibiendo ayuda de </span> 
                        <b style="text-transform:capitalize">{{user_conversation.name}}</b>,
                        <span v-if="user_conversation.user">
                            Por Favor acuerde mediante whatsapp o una llamada
                        </span> 
                    </div>
                </div>
                <div v-if="user_conversation.phone">
                    <v-btn prepend-icon="$vuetify" @click="sendWhatsapp()">
                        <v-icon>fab fa-whatsapp-square</v-icon>
                        <div style="margin-left:10px">
                            Whatsapp
                        </div>
                    </v-btn>
                   <v-btn prepend-icon="$vuetify" @click="goTocall()">
                        <v-icon>fa-solid fa-phone</v-icon>
                        <div style="margin-left:10px">
                            Llamar
                        </div>
                    </v-btn>
                </div>
            </div>
        </v-flex>
    </v-layout>
</main>

</template>

<script>
import initVue from '../../../../helpers/initVue'
import Navbar from '../../Views/Navbar'
import modaldescription from '../../Views/modaldescription'
import conversation from '../Chat/conversation'
import new_message from '../Chat/new_message_user'

import listcart from '@/components/partials/listcart.vue'
import { HelpStorage, IdentStorage, OrderStorage, UsersStorage } from '@/helpers/storage'
import { LCircle, LCircleMarker, LIcon, LMap, LMarker, LPopup, LTileLayer, } from 'vue2-leaflet'
import {
    mapGetters
} from 'vuex'



//console.log(datacompany)
const alertify = require('alertifyjs')

export default {
    
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    
    data(){
        return {
            user_help_location:[ -75.2106,-12.0681],
            user_help:null,
            user_location:null,
            user_default:'user',
            user:null,
            user_location_cache:null,
            shares:[
                {
                    name:'Compartir mi ubicacion en tiempo real',
                    value:'time',
                    icon:'fas fa-map-marked',
                    active:false,
                },
                /*
                {
                    name:'Compartir mi ubicacion actual',
                    value:'now',
                    icon:'fas fa-map-marker',
                    active:false,
                }
                */
            ],
            tabs:[
                {title:'message',active:true},
                {title:'office',active:false},
                {title:'detail',active:false},
            ],
            identity: null,
            session: false,
            token: null, 
            n:4,
            iconSize: 64,
            latitude:-12.0454324, longitude:-75.2376588,
            imageUrl: 'https://picsum.photos/510/300?random',
            imageFile:'',

            isadmin: false,
            color:"#F35369",
            user_conversation:null,
            watchID:null,

            nametitle:'',
            dataHelp: null,
            datamessage:[],
            usersStorage:new UsersStorage(),
            identStorage:new IdentStorage(),
            orderStorage:new OrderStorage(),
            helpStorage:new HelpStorage(),

        }
    },
    sockets:{
        'location:user-shared'(data){
            this.locationChange(data)
        },
        'location:user-permission'(data){
            if(this.user_conversation.id==data.id_user){
                this.$set(this.user_conversation,'permission',data.permission)
                if(data.permission){
                    this.notificacionBasica(null,`${data.user_name} está compartiendo su ubicacion`)
                }
                else{
                    this.notificacionBasica(null,`${data.user_name} dejó de compartir su ubicacion`)
                }
            }
            if(this.user_conversation.user==undefined){
                var help=this.helpStorage.get()
                var index=this.findContacts(help,this.user_conversation.id)
                if(index!=-1){
                    help.contacts[index].permission=data.permission;
                    this.helpStorage.set(help)
                }
            }
        }
    },
    components:{
        'component-listcart':listcart,
        'component-new-message':new_message,        
        'component-conversation':conversation,Navbar, 'component-modaldescription':modaldescription,LMap, LIcon, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker
    },
    async created(){
        this.user_default=this.$route.query.type||this.user_default
        var data=this.usersStorage.get();
        var iden=this.identStorage.get()
        this.user={
            id:iden._id,
            name:data.fullname,
            photo:data.photo
        }
        await this.findUser()
        this.getidentity()
        //this.recuvaLocation()
        this.color=this.$route.query.color?'#'+this.$route.query.color:"#F35369";
        this.user_help=this.helpStorage.get();
        if(this.user_help){
            this.user_location=[this.user_help.location.coordinates[0],this.user_help.location.coordinates[1]]
        }
        this.permissionLocation();
        
    },
    mounted(){
        //this.getdatacompanybysearchinrucorname()
    },
    methods:{
        notificacionBasica(data,mesg='') {
            var message=mesg;

            try{
                this.Push.create("Gootwork", {
                    body: message,
                    icon: '/favicon.ico',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            }
            catch($e){
                console.log($e)
            }

        },
        checkedPermission(){
            var helpStorage=this.helpStorage.get();
            var help_id='';
            if(this.user_conversation==null){
                return;
            }
             if(this.user_conversation.user==undefined){
                 if(helpStorage){
                   help_id=helpStorage.id;
                }
             }
             else{
                help_id=this.user_conversation._id;
             }
            axios.get(`user/help-permission-location/${help_id}?type=${this.user_default}`)
            .then(res=>{

                if(res.data){
                    var {data}=res.data;
                    if(data.user.permission) this.shares[0].active=data.user.permission
                    else this.shares[0].active=data.user.contacts[0].permission
                }
            }).catch(err=>{
                alertify.error('La ayuda ya ha sido atendida o borrada')
                this.$router.back()
            })
        },
        finishHelp(data){
            axios.post('user/help-finish',{id:data.id})
            .then(res=>{
                alertify.success('Mensaje finalizado')
                var share={
                    active:true,
                };
                this.shareUbication(share)
                this.helpStorage.remove();
                this.$router.push(`/`)            
            })
            .catch(err=>{
                alertify.error('Su mensaje de ayuda no se finalizó')
            })
        },
        locationChange(data){
            this.longitude=data.longitude,
            this.latitude=data.latitude
            this.user_help_location=[this.longitude,this.latitude]
            this.user_conversation.user=this.user_conversation.user?this.user_conversation.user:data.user;
        },
        shareUbication:function(share){
            share.active=!share.active;
            var id_help=id_help;
            if(this.user_conversation.user==undefined)
            {
                var helpStorage=this.helpStorage.get();
                id_help=helpStorage.id
            }
            else{
                id_help=this.user_conversation._id;
            }
            var userStr=this.usersStorage.get();
            var data={
                user_name:userStr.fullname,
                id:id_help,
                id_user:this.identity._id,
                type:this.user_default,
                id_conversation:this.user_conversation.id,
                permission:share.active
            }
            this.$socket.emit('location:permission',data)
            this.recuvaLocation();
        },
        selectUser:function(data){
            this.user_conversation={
                id:data._id,
                name:data.fullname,
                avatar:data.photo,
                session:null
            };
            this.permissionLocation()
            this.isTabActive(0)
        },
        permissionLocation(){
             if(this.user_conversation){
                 if(this.user_conversation.user){
                     this.$set(this.user_conversation,'permission',this.user_conversation.user.permission)
                }
                else{
                    var help=this.helpStorage.get()
                    var index=this.findContacts(help,this.user_conversation.id)
                    if(index!=-1){
                        this.$set(this.user_conversation,'permission',help.contacts[index].permission)

                    }
                }
             }
        },
        findContacts(array,value){
            return array.contacts.findIndex(el=>{return el._id==value});
        },
        getNewMessage:function(idroom){
            if(idroom==undefined) return;

            axios.get(`user/new-message/${idroom}`)
            .then(res=>{
                const {data}=res.data;
                if(data != null){
                    this.datamessage=data.chats;
                    //console.log(this.datamessage)
                    if(this.datamessage != null){
                        
                        //this.viewCountMessage = this.datamessage.length
                    }else{
                        //this.viewCountMessage = 0
                    }
                }
                

                //console.log(this.datamessage)
            })
        
        },
        findUser:async function(){
            let datauser = this.$route.query.datauser
            if(this.user_default=='user'){
                await this.axios.get(`user-simple-search/${datauser}`)
                .then(res=>{
                    if(res.data !=null){
                        var {data}=res.data
                        this.user_conversation={
                            id:data.id,
                            avatar:data.photo,
                            name:data.fullname,
                        }
                    }
                }).catch(err=>{
                    alertify.error('La ayuda ya ha sido atendida o borrada')
                    this.$router.back()
                })
                this.checkedPermission()
                return;
            }
            await this.axios.get(`user-search/${datauser}`)
            .then(res=>{
                if(res.data !=null){
                    var {data}=res.data
                    this.user_conversation={
                        _id:data._id,
                        id:data.user._id_user,
                        avatar:[{link:data.user.avatar}],
                        name:data.user.name,
                        user:data.user,
                        phone:data.user.phone,
                        location:data.location
                    }
                    this.longitude=data.location.coordinates[0],
                    this.latitude=data.location.coordinates[1]

                    this.user_help_location=[this.longitude,this.latitude]

                }
            }).catch(err=>{
                alertify.error('La ayuda ya ha sido atendida o borrada')
                this.$router.back()
            })
            this.checkedPermission()

        },
        findMessage(){
            var iden=this.identStorage.get()
            this.getNewMessage(iden._id)

        },
        isTabActive:function(index){
            //console.log(index);
            if(index==1){
                this.findMessage()
            }
            this.tabs.forEach(element=>{
                element.active=false;
            });
            this.tabs[index].active=true;
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            
        },
        recuvaLocation:function(){
            if(navigator.geolocation){
                
                this.watchID=navigator.geolocation.watchPosition(this.successPosition,this.failurePosition,{
                    timeout:60000,
                })
                if(!this.shares[0].active){
                  navigator.geolocation.clearWatch(this.watchID)

                }
            }
            else{
                alert('not supported')
            }
        },
        async successPosition(position){
            //console.log('prueba',position);
            this.latitude=position.coords.latitude;
            this.longitude=position.coords.longitude;
            this.user_location=[this.longitude,this.latitude]

            //var direction= await this.ubigeoDirection({lat:position.coords.latitude, lng:position.coords.longitude})
            //console.log(direction)
            this.sendLocation();
            //this.meLocation();
        },
        failurePosition:function(err){
            console.log('Error',err);
            //this.getdefaultcoordinates()
            //this.checked()
        },
        goTocall:function(){
           window.open('tel:'+this.user_conversation.phone, '_blank');
        },
        sendWhatsapp:function(){
           window.open('https://wa.me/'+this.user_conversation.phone, '_blank');
        },
        sendLocation:function(){
                var user={
                    'id':this.identity?this.identity._id:null,
                    'id_conversation':this.user_conversation.id,
                    'user':this.user,
                    'channel':'1',
                    'latitude':this.latitude,
                    'longitude':this.longitude,
                };
                if(this.shares[0].active){
                    //console.log(user)
                    if(this.user_location_cache!=null){
                        if(this.user_location_cache[0]!=this.longitude){
                            this.$socket.emit('location:user-share',user);
                        }
                    }
                    else{
                        
                        this.$socket.emit('location:user-share',user);

                    }
                    this.user_location_cache=[this.longitude,this.latitude]
                }
                else{
                    navigator.geolocation.clearWatch(this.watchID)
                }
                
                //this.getLocation(user);
                //this.$socket.emit('location:user',user);
        },
    }
}
</script>
